import { Button, IconButton, Tooltip } from '@material-ui/core';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { EmptyState, Link } from '@backstage/core-components';
import { CatalogTableRow } from '@backstage/plugin-catalog';
import { SERVICE_TYPE, deleteServiceUrl, routes } from '../../lib/viva';
import { EntityArgoAppsCell } from './cells';
import { serviceColumns } from './columns';
import { TypedCatalogPage } from './TypedCatalogPage';

const columns = serviceColumns<CatalogTableRow>(
  row => <EntityArgoAppsCell entity={row.entity} />,
  // удаление — шаблон «Удалить сервис» с уже выбранным сервисом
  row => (
    <Tooltip title="Снять сервис с кластера">
      <IconButton
        component={Link}
        to={deleteServiceUrl(row.entity)}
        size="small"
        aria-label="Снять сервис с кластера"
      >
        <DeleteOutlineIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  ),
);

export const ServicesPage = () => (
  <TypedCatalogPage
    section="services"
    title="Сервисы"
    subtitle="Сервисы классической разработки: образ из Dockerfile, деплой через ArgoCD в dev, stage, prod и feature-стенды"
    kind="component"
    type={SERVICE_TYPE}
    columns={columns}
    withLifecycle
    create={{ title: 'Новый сервис', to: routes.newService }}
    support="Сервис создаётся шаблоном «Новый сервис» (Go, PHP, Python, Java, Node, статика): CI собирает образ, рендерит чарт платформы и регистрирует версию в реестре кластера, ArgoCD разворачивает окружения. Удаление — шаблон «Удалить сервис»: снимает со всех окружений кластера; репозиторий и запись в каталоге остаются."
    emptyContent={
      <EmptyState
        missing="data"
        title="Сервисов пока нет"
        description="Создайте первый сервис из шаблона «Новый сервис» — проект появится здесь после регистрации в каталоге."
        action={
          <Button variant="contained" color="primary" href={routes.newService}>
            Новый сервис
          </Button>
        }
      />
    }
  />
);
